import { Typography, Card } from '@mui/material'

function Home() {
  return (
    <div
      style={{
        marginTop: '5%',
        marginBottom: '5%',
        marginLeft: '10%',
        marginRight: '10%',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src="https://i.imgur.com/uMoBVbS.png"
          alt="logo"
          style={{ width: '10%', height: '16%' }}
        />
      </div>
      <div>
        <Typography
          align="center"
          sx={{
            fontFamily: 'Righteous',
            fontWeight: 300,
            fontSize: 70,
            color: 'black',
            textDecoration: 'none',
            mb: 2,
          }}
        >
          TeaLink
        </Typography>
      </div>

      <Card sx={{ mb: 3 }} raised>
        <Typography
          align="center"
          color="secondary"
          sx={{
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'Spline Sans Mono',
            p: 2,
          }}
        >
          Welcome to TeaLink, the first open-ended peer-to-peer news betting
          protocol on the Ethereum network.
        </Typography>

        <Typography align="center" sx={{ p: 3 }}>
          TeaLink provides a platform for users to create custom bets on
          anything and everything, using a Chainlink oracle and NewsAPI.org to
          verify whether or not the bet-upon event has occurred by searching for
          keywords given by the bet creator in news headlines.
        </Typography>
      </Card>
      <Card sx={{ mb: 3 }} raised>
        <Typography
          align="center"
          color="secondary"
          sx={{
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'Spline Sans Mono',
            p: 2,
          }}
        >
          Here’s how it works:
        </Typography>
        <Typography sx={{ p: 3 }}>
          You can create a bet that something will happen by selecting keywords
          or key-phrases that you believe will appear in future headlines if the
          event comes to pass. For example, if you think that A$AP Rocky and
          Rihanna will break up, you might create a bet with “Rocky”, “Rihanna”,
          and “break up” as your keywords. Once your bet is created it will be
          listed on the bet marketplace where other users can buy-in to accept
          it. News API will then query every headline generated by relevant
          outlets for your keywords, and if enough headlines containing them are
          found you will win your TeaLink bet! Using our novel headline keyword
          betting mechanism, TeaLink allows users to make bets in both
          traditional areas, like the outcome of sporting events - using for
          example “Verstappen” + “Wins” + “Monaco Grand Prix” as keywords - and
          in areas that have never before been included in organized betting
          such as celebrity relationships, the outcomes of prominent lawsuits,
          global conflicts, etc.
        </Typography>
      </Card>
      <Card sx={{ mb: 3 }} raised>
        <Typography
          align="center"
          color="secondary"
          sx={{
            fontSize: 20,
            fontWeight: 700,
            fontFamily: 'Spline Sans Mono',
            p: 2,
          }}
        >
          Creating a bet:
        </Typography>
        <Typography sx={{ px: 3, pb: 3 }}>
          Heading over to our “Create Bet” page, you will see that you get to
          set a variety of parameters for each bet you create. Let’s run through
          each one.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Title: What your bet will be called on the bet marketplace.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Accept by date: The deadline for your bet to be accepted by another
          user. If your bet is not accepted by the accept by date, it will
          expire and your ETH will be refunded.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Bet expiration date: The deadline for the event to occur if your bet
          is accepted. Bet amount: The amount you as the bet creator are
          wagering on your side of the bet. Your bet amount will be deposited
          into the protocol upon bet creation, and will either be returned if
          your bet is not accepted by the “accept by” date, returned along with
          winnings (i.e. accept value) if your bet is accepted and you win, or
          lost to the person betting against you if the bet expiration date
          arrives without the keyword conditions being met.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Accept value: The value that somebody betting against you must wager
          to enter the bet. If a user wants to accept your bet on the bet
          marketplace, they will have to deposit the accept value. By setting
          both the bet amount and accept value, you get to set the odds on each
          bet you create.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Number of Articles: The number of articles with headlines containing
          your keywords needed to fulfill the bet.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Keywords: The words that News API will search for to determine if your
          event has occurred or not. This is the core substance of the bet. Note
          that all keywords must be present in a headline for it to count
          towards the given number of articles. It doesn’t matter which order
          the words are in, so long as they are all present. If you give
          keywords as phrases, for example “Biden re-elected” vs. “Biden” +
          “re-elected”, only articles containing the entire phrase will count
          towards the given number of articles.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Picking the sources: If you choose not to pick sources, News API will
          query its entire catalog of news outlets, including over 80,000
          publications and reputable blogs, for titles containing your keywords.
          Alternatively, you can choose to limit the scope of the query to any
          combination of the 27 major news outlets shown on the “create bet”
          page.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Once a bet is created, it is listed in full on the bet marketplace
          under “open bets” and users can accept it by wagering the accept
          value. If a bet is accepted, it will appear under the “accepted bets”
          tab in the bet marketplace where users can check the status of their
          bets.
        </Typography>
        <Typography sx={{ px: 3, pb: 2 }}>
          Key details: All bets are made in Ethereum. All bet creations carry a
          service fee of .001 ETH to cover the cost of Chainlink services used
          to validate the bet. As there is a cost associated with checking if a
          bet has been won, the protocol will only automatically determine the
          winner at the bet expiration date. However users can pay gas fees to
          check the status of their bet at any time, and if the bet creator’s
          win conditions have been met the bet will immediately close and the
          payout will occur.
        </Typography>
      </Card>
    </div>
  )
}

export default Home
